export const contentGenresList = [
  {
      label: "Content Genre",
      options: [
          {
              label: "Comedy",
              value: "Comedy",
              name: "Comedy"
          },
          {
              label: "Documentary",
              value: "Documentary",
              name: "Documentary"
          },
          {
              label: "Drama",
              value: "Drama",
              name: "Drama"
          },
          {
              label: "Entertainment",
              value: "Light Entertainment",
              name: "Entertainment"
          },
          {
              label: "Lifestyle",
              value: "Infotainment / Lifestyle",
              name: "Lifestyle"
          },
          {
              label: "Movies",
              value: "Movies",
              name: "Movies"
          },
          {
              label: "News",
              value: "News / Current Affairs",
              name: "News"
          },
          {
              label: "Reality",
              value: "Reality Television",
              name: "Reality"
          },
          {
              label: "Sports",
              value: "Sports Event",
              name: "Sports"
          }]
  }
]
